<template>
  <v-container fluid grid-list-md class="tp-page">
    <div class="tp-page-head">
      <div>
        <h1 class="tp-page-title">Transações</h1>
        <p class="tp-page-sub">{{ tabela.conteudo.length }} no total</p>
      </div>
      <div class="tp-head-actions">
        <v-text-field
          v-model="tabela.busca"
          prepend-inner-icon="mdi-magnify"
          placeholder="Buscar…"
          hide-details
          dense
          outlined
          color="#00695C"
          class="tp-search"
        ></v-text-field>
      </div>
    </div>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" label="Selecione o Evento" @input="carregaInscritos()" color="#00695C"></v-select>
      </v-col>
    </v-row>
    <v-layout row wrap>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedInicio"
              label="Data Inicio"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedInicio)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaInicio"
          label="Hora Início"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedFim"
              label="Data Fim"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedFim)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaFim"
          label="Hora Fim"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg3>
        <v-select
          v-model="formasDePagamento"
          :items="formasPagamento"
          label="Status de pagamento"
          multiple
          attach
          outlined
          dense
        ></v-select>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-btn dark depressed rounded class="tp-btn-add" @click="carregaDados" color="#00695C"><v-icon left>mdi-magnify</v-icon>Buscar</v-btn>
      </v-flex>
    </v-layout>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-card class="tp-card" elevation="0">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          :loading="tabela.carregamento"
          loading-text="Aguarde, buscando transações..."
        >
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhuma transação encontrada</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="body.append">
            <tr>
              <td :colspan="tabela.cabecalho.length">
                <h2 style="margin: 0 auto; text-align: center">Total: {{ campoSoma('valor').toString().replace('.',',') }}</h2>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.valor`]="{ item }">
            R$ {{ item.valor }}
          </template>
          <template v-slot:[`item.statusPagamento`]="{ item }">
            <v-chip v-if="item.statusPagamento == 'PENDENTE'" color="warning" dark small>{{ item.statusPagamento }}</v-chip>
            <v-chip v-if="item.statusPagamento == 'PAGO'" color="success" dark small>{{ item.statusPagamento }}</v-chip>
            <v-chip v-if="item.statusPagamento == 'CANCELADO'" color="error" dark small>{{ item.statusPagamento }}</v-chip>
          </template>
          <template v-slot:[`item.codigoTransacao`]="{ item }">
            <td><a :href="item.codigoTransacao" target="_blank" style="text-decoration: none">Visualizar</a></td>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            {{ formatDateHour(item.created) }}
          </template>
        </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: {Snackbar,},
    data: vm => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      configAccess: false,
      tabela: {
        cabecalho: [
          { text: 'Valor', value: 'valor' },
          { text: 'Quantidade de Ingressos', value: 'quantidadeInscricoes', },
          { text: 'Status', value: 'statusPagamento' },
          { text: 'Lote', value: 'lote' },
          { text: 'Divulgador', value: 'divulgador.nome' },
          { text: 'Realizado em', value: 'created' },
          { text: 'Comprovante', value: 'codigoTransacao' },
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      horaInicio: '00:00',
      horaFim: '23:59',
      editedIndexCat: -1,
      editedIndexProd: -1,
      formasPagamento: ['CANCELADO','PAGO','PENDENTE'],
      formasDePagamento: ['CANCELADO','PAGO','PENDENTE'],
      eventos: [],
      eventoId: '',
      eventoIdAtual: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndexProd === -1 ? 'ADICIONAR NOVO PRODUTO' : 'EDITAR PRODUTO'
      },  
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },
      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },
    },

    mounted () {
      this.carregaDados()
    },

    methods: {
      async carregaDados() {
          this.isLoading = true
            await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"${this.companyobj.id}"}]}}&access_token=${sessionStorage.getItem('accToken')}`)
          .then(res => {
            if (res.data != '') {
              for (var key in res.data) {
                if (res.data.hasOwnProperty(key)) {
                  this.eventos.push(res.data[key])
                }
              }
              this.eventos = this.eventos.sort(this.compare)
              this.eventoId = this.eventos[0].id
              if (this.eventoIdAtual != '')
                this.eventoId = this.eventoIdAtual
            } else
              this.isLoading = false
          })
          this.quantidade = []
          for (let i = 0; i < 51; i++) {
            if (i > 0) {
              this.quantidade.push(i)
            }
          }
        await this.carregaTransacoes()
      },

      async carregaTransacoes () {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        let whereor = '['
        if (this.formasDePagamento.length >= 1) {
          for (let i = 0; i < this.formasDePagamento.length; i++) {
            whereor += '{"statusPagamento":"' + this.formasDePagamento[i].toString() + '"}'
            if (i < (this.formasDePagamento.length - 1)) {
              whereor += ','
            }
          }
          whereor += ']'
          await axios.get(`${baseApiUrl}Transacaos?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"or":${whereor}},{"created":{"gt":"${this.dataInicio}T${this.horaInicio}:00.000Z"}},{"created":{"lt":"${this.dataFim}T${this.horaFim}:00.000Z"}}]}, "include":"divulgador"}&access_token=${sessionStorage.getItem('accToken')}`)
          .then(response => {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          })
        } else {
          await axios.get(`${baseApiUrl}Transacaos?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"created":{"gt":"${this.dataInicio}T${this.horaInicio}:00.000Z"}},{"created":{"lt":"${this.dataFim}T${this.horaFim}:00.000Z"}}]}, "include":"divulgador"}&access_token=${sessionStorage.getItem('accToken')}`)
          .then(response => {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          })
        }
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' ' + hora
      },

      campoSoma(key) {
        // sum data in give key (property)
        return 'R$ ' + this.tabela.conteudo.reduce((a, b) => (parseFloat(a) + parseFloat(b[key])).toFixed(2), 0)
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()

        let comparison = 0;
        if (dataC >= dataA)
          comparison = 1;
        /* else if (dataA >= dataC && dataB < dataA)
          comparison = -1; */
        else if (dataC < dataA)
          comparison = -1;
        return comparison;
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
